<div class="auth-layout">

  <!-- Imagen izquierda -->
  <div class="auth-layout-image">
    <img src="hero_image.jpg" alt="Equipo FID Seguros">
  </div>

  <!-- Contenido derecha -->
  <div class="auth-layout-content">
    <ng-content></ng-content>
  </div>

</div>
